import React from 'react';
import moment from 'moment';

import { useSiteOptions, useUrl } from 'hooks';
import { APIContext } from '@/globals/contexts';

import Head from 'next/head';

function generateStructuredData(
  content,
  baseUrl,
  { siteOptions, getImageUrl }
) {
  switch (content._cls) {
    case 'Author':
      return null;
    case 'MagazineArticle':
    case 'TextContent':
    case 'VideoContent':
      return {
        '@context': 'https://schema.org/',
        '@type': 'Article',
        articleSection: content.contentType?.map((category) => category.label),
        author: content.authors.map((author) => {
          return {
            '@type': 'Person',
            name: author.label,
            url: `${baseUrl}${author.path}`,
            jobTitle: author.occupation,
          };
        }),
        datePublished: moment.unix(content.publishTs).format(),
        description: content.seoDescription,
        headline: content.seoLabel,
        image: [getImageUrl(content.image)],
        keywords: content.mainTags?.map((tag) => tag.text),
        publisher: {
          '@type': 'Organization',
          name: siteOptions.siteTitle,
          url: baseUrl,
        },
        isAccessibleForFree: !!content.isFree,
        hasPart: {
          '@type': 'WebPageElement',
          isAccessibleForFree: !!content.isFree,
          cssSelector: '.paywalled',
        },
      };
    default:
      return null;
  }
}

export default function ContentStructuredDataHeader({ content }) {
  const { baseUrl } = useUrl();
  const siteOptions = useSiteOptions();
  const { getImageUrl } = React.useContext(APIContext);

  const structuredData = generateStructuredData(content, baseUrl, {
    siteOptions,
    getImageUrl,
  });

  if (!structuredData) return null;

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(structuredData),
        }}
      />
    </Head>
  );
}
